import '../../../../../../Avency.Sprehe.Base/Resources/Private/Assets/JavaScript/Project/globals';

// Dieses JS fügt eine gradient-Klasse hinzu, sobald der Content der Tabelle
// größer ist, als der Div-Container der außen rum liegt.
// Außerdem wird getestet, ob man am Ende der Scrollleiste angekommen ist.
// Falls ja, dann wird der Gradient wieder ausgeblendet, um den Content am Ende der
// Tabelle zu sehen.

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($('.table-responsive').length) {
            if ($('.table-responsive')[0].scrollWidth > $('.table-responsive')[0].clientWidth) {
                $('.table-overlay-wrapper').addClass('table-overlay');
            } else {
                $('.table-overlay-wrapper').removeClass('table-overlay');
            }
            $('.table-responsive').on('scroll', function () {
                if ($('.table-responsive')[0].offsetWidth + $('.table-responsive')[0].scrollLeft == $('.table-responsive')[0].scrollWidth) {
                    $('.table-overlay-wrapper').removeClass('table-overlay');
                } else {
                    $('.table-overlay-wrapper').addClass('table-overlay');
                }
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
